import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import en from "./en.json";
import es from "./es.json";

const stored = localStorage.getItem("dd_lang");
const browser = (navigator.language || "en").slice(0, 2);
const initial = stored || (browser === "es" ? "es" : "en");

i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, es: { translation: es } },
  lng: initial,
  fallbackLng: "en",
  interpolation: { escapeValue: false },
});

export function setLanguage(lang) {
  localStorage.setItem("dd_lang", lang);
  i18n.changeLanguage(lang);
  document.documentElement.lang = lang;
}

export function currentLanguage() {
  return i18n.language?.startsWith("es") ? "es" : "en";
}

document.documentElement.lang = initial;

export default i18n;
